"use strict";
module.exports = Object.freeze({
    DAY: 'day',
    WEEK: 'week',
    MONTH: 'month',
    YEAR: 'year',
});
//# sourceMappingURL=durationUnits.js.map